export default "__VITE_ASSET__BUqCB8pt__"